import { ResponseModel } from '@agent/agent-interface/helpzone/knowledge-base/models/responseModel';
import { createAction, props, union } from '@ngrx/store';

export const SuggestedResults = createAction(
  '[Agent/KnowledgeBase] Suggested Results',
  props<{
    suggestedResults: ResponseModel[];
  }>()
);

export const SearchResults = createAction(
  '[Agent/KnowledgeBase] Search Results',
  props<{
    searchResults: ResponseModel[];
  }>()
);

const actions = union({
  SearchResults,
  SuggestedResults,
});

export type ActionUnion = typeof actions;
